var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm5.75-12.661a1.518 1.518 0 0 0-1.062-1.083C15.753 8 12 8 12 8s-3.753 0-4.688.256A1.518 1.518 0 0 0 6.25 9.339C6 10.293 6 12.286 6 12.286s0 1.992.25 2.947c.14.527.545.941 1.062 1.082.935.256 4.688.256 4.688.256s3.753 0 4.688-.256a1.518 1.518 0 0 0 1.061-1.082c.251-.955.251-2.947.251-2.947s-.001-1.993-.25-2.947Zm-6.951 4.783 3.117-1.836-3.117-1.837v3.673Z",
    fill: "currentColor"
  })));
};
export default SvgYoutube;